import { NotificationBarsTheme } from "@acin.reactjs/acin-ui/notificationBar";
import theme, {
  applyIconColor,
  ComponentCSSStyle,
  getMaxWidthMediaQuery,
} from "@acin.reactjs/acin-ui/theme";

const notificationBarsTheme: ComponentCSSStyle<NotificationBarsTheme> = {
  notification: {
    root: {
      minHeight: "auto",
    },
    content: {
      root: {
        [getMaxWidthMediaQuery(theme.breakpoints.md)]: {
          alignItems: "center",
          flexDirection: "row",
        },
      },
    },
    skipButton: {
      root: {
        display: "flex",
        alignItems: "center",
        svg: applyIconColor(theme.palette.common.black),
      },
      label: {
        display: "flex",
      },
    },
  },
};

export default notificationBarsTheme;
